import React from 'react';

const ZoomboxCredits = () => {
  return (
    <div className="ZoomboxCredits">
      Image preview powered by{' '}
      <a href="https://worldsofashishpatel.com/projects/zoombox/" target={'_blank'} rel="noopener noreferrer">
        Zoombox
      </a>
    </div>
  );
};

export default ZoomboxCredits;
